<style scoped>
  .page-holder{
    height: 130px;
    background: #fff;
    display: flex;
  }
  .page-header {
    width: 100%;
    padding: 10px;
  }
  .content-image {
    width: 230px;
    height: 100%;
  }
  .image-preview-container .image{
    background-repeat: no-repeat !important;
    background-position: center !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    width:100%;
    height: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
  .image-preview-container{
    width: 100%;
    height: 100%;
  }
  .group-description{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  /* .p-marginer > p {
    padding-bottom: 10px;
  }
  .p-marginer > ul,
  .p-marginer > ol {
    padding-left: 15px;
  } */

  .comments {
    position: absolute;
    bottom: 7px;
    left: 10px;
  }

  .comments > span{
    font-size: 1em;
  }
</style>

<style>
  .group-info-video > div{
    height: 100%;
  }
</style>

<template>
  <div class="pages-list-component">
    <div v-for="(page, indx) in orderedPages" :key="indx" style="margin-bottom:10px">
      <Card shadow :style="{borderRadius: '0'}" :padding="0">
      <div class="page-holder" v-on:click="viewActivity(page)" style="position: relative">
        <div class="page-header">
          <!-- <h3>{{page.title}}</h3> -->
          <small>
            <b style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden; font-size: 1.2em;line-height:1.2em">{{page.title}}</b>
          </small>
          <p v-if="!page.cover_photo_uri" class="block-with-text" style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden; font-size: 0.8em;margin-top:10px;" v-html="removeHTMLTags(page.data.text  || page.data.tip || page.data.description)"></p>
          <div class="header" style="margin-top: 5px;">
            <!-- use updated_at instead of rrule_parsed_date because of no recurrence. -->
            <timeago :since="page.updated_at" style="display:block;color: rgb(154, 154, 154);margin-top:-2px;font-size:9px"></timeago>
          </div>
          <!-- <small style="color: rgb(154, 154, 154);"><timeago :since="page.updated_at"></timeago></small> -->
          <!-- <p class="p-marginer group-description" v-if="page.type == 'statement'" v-html="removeHTMLTags(page.data.tip)"></p> -->
        </div>
        <div class="content-image" v-if="page.cover_photo_uri">
          <div class="image-preview-container" v-if="page.cover_photo_uri">
            <!-- <img :src="postPreviewImage(page)" @click="showVuer" width="100%" alt="IMAGE">
            <viewer v-show="false" :options="vuerOptions" @inited="initVuer" :images="page.cover_photo" class="viewer" ref="viewer">
              <img :src="page.cover_photo[0].original" width="100%" alt="IMAGE">
            </viewer> -->
            <div class="image" :style="{background: 'url('+ postPreviewImage(page) +')'}">
              <span class="feed-icons">
                <Avatar v-if="page.type == 'attachment' && page.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                <!-- <Avatar v-if="page.type == 'attachment' && page.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar> -->
                <Avatar v-if="page.type == 'attachment' && page.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
              </span>
            </div>
          </div>
          <div v-else class="image-preview-container">
            <div v-if="page.type == 'attachment'" style="width: 100%; height: 100%">
              <div v-if="page.data.attachment_type == 'video'" style="width: 100%; height: 100%; position: relative" class="group-info-video">
                <youtube v-if="page.type === 'attachment' && page.data.attachment_type === 'video'"
                  :video-id="getVideoId(page.data.url)" @ready="onYtReady"
                  :player-height="'100%'" player-width="100%">
                </youtube>
                <Spin size="large" fix v-if="page.type === 'attachment' && page.data.attachment_type === 'video' && !isPlayerReady"></Spin>
              </div>
              <div v-if="page.data.attachment_type == 'slideshow'">
                <slideshow-component :slideshow-item="page.data"
                  :cover-photo="postPreviewImage(page)"
                  :slideshow-description="page.data.text"/>
              </div>
            </div>
          </div>
        </div>
        <!-- <small class="comments"><router-link style="color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + page.id + '?scroll=true'"><i class="far fa-comment"></i>&nbsp;
            Comments {{ (page.activity_count > 0) ? page.activity_count : ''}}</router-link></small> -->
      </div>

      <!-- <div class="page-holder" v-if="page.type == 'attachment'">
        <div v-if="page.data.attachment_type === 'slideshow'">
          <div v-if="page.data.attachment_type === 'slideshow'">
            <slideshow-component :slideshow-item="page.data"
              :cover-photo="postPreviewImage(page)"
              :slideshow-description="page.data.text"/>
          </div>
        </div>
        <div v-else class="page-content">
          <div class="content-info">
            <p class="p-marginer" v-html="page.data.text"></p>
          </div>
        </div>
      </div> -->

      <!-- <div class="page-holder" v-if="page.type == 'statement'">
        <div class="page-content">
          <div class="content-info">
            <p class="p-marginer" v-html="page.data.tip"></p>
          </div>
        </div>
      </div> -->

      <!-- <div class="page-holder" v-if="page.type == 'event_info'">
        <div class="page-header">
          <h3>{{page.title}}</h3>
        </div>
        <div class="page-content">
          <div class="content-image">

          </div>
          <div class="content-info">
            <p><Icon type="android-time"></Icon> {{parseDate(page.data.event_start_date)}}
               at {{parseTime(page.data.event_start_time)}} - {{parseDate(page.data.event_end_date)}}
               at {{parseTime(page.data.event_end_time)}}</p>
          </div>
        </div>
      </div> -->
    </Card>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { getIdFromURL } from 'vue-youtube-embed'
  import Viewer from "v-viewer/src/component.vue"
  import SlideshowComponent from '@/components/SlideshowComponent'

  export default {
    name: 'PagesListComponent',
    data() {
      return {
        isPlayerReady: false,
        vuerOptions: {
          navbar: false,
          title: false,
          toolbar: false,
          scalable: false,
          fullscreen: false,
          keyboard: false
        }
      }
    },
    props: {
      pageInfo: {
        type: [Object, Array],
          default: function() {
        }
      }
    },
    computed: {
      orderedPages() {
        return this.pageInfo.sort(function (a, b) {
            return ('' + a.order).localeCompare(b.order);
        })
      },
    },
    components: {
      SlideshowComponent,
      Viewer,
    },
    methods: {
      showVuer() {
        this.$viewer.show();
      },
      initVuer(viewer) {
        this.$viewer = viewer;
      },
      onYtReady(player) {
        // player.playVideo();
        return this.isPlayerReady = (player) ? true : false;
      },
      postPreviewImage (act) {
        if (act.cover_photo && act.cover_photo.length > 0 && 'medium' in act.cover_photo[0]) {
          return act.cover_photo[0]['medium']
        }
      },
      getVideoId(url) {
        return this.$youtube.getIdFromURL(url);
      },
      parseDate(date) {
        return moment(date).format("MMM D").toUpperCase()
      },
      parseTime(time) {
        return moment(time, "HH:mm").format("hh:mm A");
      },
      viewActivity (item) {
        if(item.type == 'sub_menu') {
          this.$router.push({ path: '/submenu/' + item.data.group_id, meta: { title: item.title } })
          return false;
        }

        if(item.type == 'group_page') {
          this.$router.push({ path: '/resources/' + item.data.careplan_id + '?tab=posts' })
          return false;
        }

        if(item.type == 'module_page') {
          this.$router.push({ path: '/module/' + item.data.module_id, query: { tab: 'course', floating: true }})
          return false;
        }

        if(item.type == 'element_page') {
          this.$router.push({ path: '/feed/' + item.data.element_id})
          return false;
        }
        
        this.$store.commit('feed/setSingleFeed', item)
        this.$router.push({ path: '/feed/' + item.id })
      },
      removeHTMLTags (data){
        if(data)
          return data.replace(/<\/?[^>]+(>|$)/g, "");
      }
    }
  }
</script>
